import { Box, Flex, IconButton, Text } from "@chakra-ui/react";
import { FunctionComponent } from "react";
import { MdPushPin } from "react-icons/md";

// Utils
import { NotesActivitiesDisplay } from "../../utils/types";

// Types for reusable component pro

interface NotesTileProps {
	isPinned: boolean;
	isPinDisabled?: boolean;
	data: NotesActivitiesDisplay[]; // Array of notes or activities
	noDataMessage: string; // Message to display when no data is available
	handlePinNote: (noteId: number) => Promise<void>;
	handleUnpinNote: (noteId: number) => Promise<void>;
}

const NotesTiles: FunctionComponent<NotesTileProps> = ({
	isPinned,
	isPinDisabled,
	data,
	noDataMessage,
	handlePinNote,
	handleUnpinNote
}) => {
	// Utility function to format timestamp
	const formatTimestamp = (timestamp: number): string => {
		const date = new Date(timestamp * 1000); // Assuming timestamp is in seconds
		return date.toLocaleString();
	};

	return (
		<Box overflowY="auto" pb="4" pt="2" mb="10px">
			{/* Loop through data and render each item */}
			{data && data.length > 0 ? (
				data.map((item, index) => (
					<Box key={item.id || index} borderRadius="5px" textAlign="left" mb={5}>
						{/* Header: Username and Time */}
						<Flex justifyContent="left" alignItems="flex-start" mb="8px">
							{item.type && (
								<Text
									fontSize="12px"
									px="6px"
									py="2px"
									mr={2}
									backgroundColor={item.type.color}
									borderRadius="4px"
									textAlign="center">
									{item.type.label}
								</Text>
							)}
							<Text fontSize="14px" fontStyle="italic" textAlign="left">
								{item.userName ?? "System"}, {formatTimestamp(item.createdAt)}
							</Text>
							<IconButton
								size="sm"
								colorScheme={item.isPinned ? "orange" : "blackAlpha"}
								ml={2}
								minWidth="22px"
								minHeight="22px"
								height="22px"
								aria-label="Pin Note"
								icon={<MdPushPin />}
								onClick={() => (item.isPinned ? handleUnpinNote(item.id) : handlePinNote(item.id))}
								isDisabled={isPinDisabled}
							/>
						</Flex>

						{/* Message */}
						{item.message && (
							<Box
								key={item.id || index}
								display="inline-block"
								p="10px"
								mb="0px"
								borderRadius="5px"
								backgroundColor="gray.100">
								<Text fontSize="1rem" textAlign="left" whiteSpace="pre-line" fontWeight={isPinned ? "bold" : "normal"}>
									{item.message}
								</Text>
							</Box>
						)}
					</Box>
				))
			) : (
				<Text fontSize="0.9rem" textAlign="center" mt="3">
					{noDataMessage}
				</Text>
			)}
		</Box>
	);
};

export default NotesTiles;
